export const ACTIVITY_FILTERS = {
  DEFAULT: "Default",
  NEW: "New",
  TEAM: "Team",
  UNCONFIRMED: "Unconfirmed",
};
